/**
 * @desc 保存邮件帐号
 */
const URL = "/rantion-crm";
import http, { updateResponse } from "@/http";
export function request(body: defs.crm.MailAccountRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/crm/mailAccount/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
